module.exports = __webpack_public_path__ + "img/pocket-hero-mask.fffb9ef.svg";